module.exports = __webpack_public_path__ + "img/icon_sport_type_6.7dbe0da6.png";